// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-7ca5d4a3],.fade-leave-active[data-v-7ca5d4a3]{transition:opacity .3s}.fade-enter[data-v-7ca5d4a3],.fade-leave-active[data-v-7ca5d4a3]{opacity:0}.chatBotShadow img[data-v-7ca5d4a3]{border-radius:50%;box-shadow:inset 0 0 0 1px hsla(0,0%,100%,.2),0 4px 6px rgba(0,0,0,.1),0 8px 30px rgba(0,0,0,.15);height:56px;width:56px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
